import { createActionsHook } from 'src/lib/sweetState';

import { type Actions, MainStore, type State } from './MainStore';

export const useMainActions = createActionsHook<State, Actions>(MainStore);
